import React, { useMemo } from 'react';
import DateRangeSelector from '../DateRangeSelector';
import { END_HELPER, MATCHES_HELPER, PERIOD_TOOLTIP, START_HELPER } from './constants';
import { clampWindow, formatRange, fromYmd, presetRange, toYmd } from '../../../utils/buyerInsightsDates';

// Activity from / until (spec §0.5): floored at the history start, capped at yesterday, presets
// Last 4 / Last 13 weeks. Values are YYYY-MM-DD strings; Date objects only at the picker edge.
const ActivityWindowSelector = ({ value, onChange, bounds, isWide }) => {
  const maxEnd = bounds.max_end;
  const presets = useMemo(
    () =>
      [4, 13].map((weeks) => {
        const range = presetRange(weeks, maxEnd);
        return {
          label: `Last ${weeks} weeks`,
          getRange: () => ({ start: fromYmd(range.start), end: fromYmd(range.end) }),
          tooltip: formatRange(range.start, range.end),
        };
      }),
    [maxEnd]
  );

  const handleChange = (startDate, endDate, source) => {
    const next = clampWindow({ start: toYmd(startDate), end: toYmd(endDate) }, bounds);
    onChange(next, source);
  };

  const startHelper = value.start < bounds.matches_from ? `${START_HELPER} · ${MATCHES_HELPER}` : START_HELPER;

  return (
    <DateRangeSelector
      startDate={fromYmd(value.start)}
      endDate={fromYmd(value.end)}
      onChange={(s, e) => handleChange(s, e, 'field')}
      presets={presets.map((p) => ({ ...p, getRange: () => p.getRange() }))}
      minDate={fromYmd(bounds.min_start)}
      maxDate={fromYmd(bounds.max_end)}
      labels={{ start: 'Activity from', end: 'Activity until' }}
      startHelperText={startHelper}
      endHelperText={END_HELPER}
      tooltip={PERIOD_TOOLTIP}
      chipHeight={isWide ? 32 : 40}
    />
  );
};

export default ActivityWindowSelector;
